import React from 'react';
import TaskColumn from './TaskColumn';

const StepsColumn = ({
  goals,
  selectedGoal,
  selectedStep,
  setSelectedStep,
  setSelectedTask,
  newStepText,
  setNewStepText,
  addStep,
  setGoals,
  columnHeaders,
  setColumnHeaders,
  openMenuId,
  setOpenMenuId,
  openSubmenuId,
  setOpenSubmenuId,
  filterState,
  editingItemId,
  setEditingItemId,
  editingText,
  setEditingText,
  draggedItem,
  handleDragStart,
  handleDragOver,
  handleDrop
}) => {
  const steps = goals.find((g) => g.id === selectedGoal)?.steps || [];

  const toggleStepCompletion = (stepId) => {
    const updatedGoals = goals.map((goal) => {
      if (goal.id === selectedGoal) {
        return {
          ...goal,
          steps: goal.steps.map((step) =>
            step.id === stepId ? { ...step, completed: !step.completed } : step
          ),
        };
      }
      return goal;
    });
    setGoals(updatedGoals);
  };

  const deleteStep = (stepId) => {
    const updatedGoals = goals.map((goal) => {
      if (goal.id === selectedGoal) {
        return {
          ...goal,
          steps: goal.steps.filter((step) => step.id !== stepId),
        };
      }
      return goal;
    });
    setGoals(updatedGoals);
    if (selectedStep === stepId) {
      setSelectedStep(null);
      setSelectedTask(null);
    }
    setOpenMenuId(null);
    setOpenSubmenuId(null);
  };

  const setStepPriority = (stepId, priority) => {
    const updatedGoals = goals.map((goal) => {
      if (goal.id === selectedGoal) {
        return {
          ...goal,
          steps: goal.steps.map((step) =>
            step.id === stepId ? { ...step, priority: priority } : step
          ),
        };
      }
      return goal;
    });
    setGoals(updatedGoals);
    setOpenMenuId(null);
    setOpenSubmenuId(null);
  };

  const updateStepTitle = (stepId, newTitle) => {
    const updatedGoals = goals.map(g => 
      g.id === selectedGoal ? {
        ...g, 
        steps: g.steps.map(s => 
          s.id === stepId ? {...s, title: newTitle} : s
        )
      } : g
    );
    setGoals(updatedGoals);
    setEditingItemId(null);
  };

  return (
    <TaskColumn
      type="step"
      items={steps}
      selectedId={selectedStep}
      setSelectedId={setSelectedStep}
      newItemText={newStepText}
      setNewItemText={setNewStepText}
      addItem={addStep}
      toggleCompletion={toggleStepCompletion}
      columnHeaders={columnHeaders}
      setColumnHeaders={setColumnHeaders}
      headerKey="steps"
      openMenuId={openMenuId}
      setOpenMenuId={setOpenMenuId}
      openSubmenuId={openSubmenuId}
      setOpenSubmenuId={setOpenSubmenuId}
      deleteItem={deleteStep}
      setPriority={setStepPriority}
      goalId={selectedGoal}
      filterState={filterState}
      editingItemId={editingItemId}
      setEditingItemId={setEditingItemId}
      editingText={editingText}
      setEditingText={setEditingText}
      updateItemTitle={updateStepTitle}
      draggedItem={draggedItem}
      handleDragStart={handleDragStart}
      handleDragOver={handleDragOver}
      handleDrop={handleDrop}
      isDisabled={!selectedGoal}
    />
  );
};

export default StepsColumn; 